/** Punto de entrada de la aplicación: monta <App /> en #root con ReactDOM e importa los estilos globales (index.css y sileo). */
import ReactDOM from "react-dom/client";
import "./index.css";
import "sileo/styles.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);
